import { COOKIES } from 'appConstants';
import { getCookieByName } from '../services/cookies';

export const getApphubBackOfficeUrl = (): string => decodeURIComponent(getCookieByName(COOKIES.apphubBackOfficeURL));
